import {asyncActionsFactory} from '@wix/wix-events-commons-statics'
import {State, StoreExtraArgs} from '../types'

export const createAsyncAction = asyncActionsFactory<State, StoreExtraArgs>()
